export default __webpack_public_path__ + "static/media/feature_3@2x.abf85fe0.png";